import React from "react";
// @ts-ignore
import Swal from "sweetalert2";

export interface AnswerItem {
  id: string | number;
  description: string;
  isCorrect: boolean;
}

export interface QuizItem {
  id: string | number;
  description: string;
  answers: AnswerItem[];
}

export interface QuizProps {
  quiz: QuizItem[];
  answers: Record<string, AnswerItem>;
  showAns: boolean;
  passed: boolean;
  selectChange: (element: AnswerItem, item: QuizItem) => void;
  checkAnswers: () => void;
}

const Quiz: React.FC<QuizProps> = (props) => {
  const { quiz, answers, showAns, passed, selectChange, checkAnswers } = props;

  return (
    <>
      {quiz.length > 0 ? (
        <div className="container-xxl mt-5 mh-120vh ">
          <div className="row">
            <div className="col-12">
              <h1>MCQ's</h1>
            </div>
            {quiz.map((item, index) => {
              return (
                <div className="col-12 my-3" key={item.id}>
                  <h6>
                    {index + 1}- {item.description}
                  </h6>

                  <div className="row">
                    {item.answers.map((element, i) => {
                      return (
                        <div
                          key={i}
                          className="col-12 col-sm-12 my-2 col-md-3"
                        >
                          <p
                            className={
                              showAns && answers[item.id]?.id === element.id
                                ? "text-danger fw-bold"
                                : element.isCorrect && showAns
                                ? "text-success fw-bold"
                                : ""
                            }
                          >
                            <input
                              disabled={showAns}
                              type="radio"
                              onChange={() => {
                                selectChange(element, item);
                              }}
                              name={item.id.toString()}
                            />{" "}
                            &nbsp; {element.description}{" "}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
            <div className="col-12">
              {showAns && !passed && (
                <a
                  href={window.location.href}
                  className="btn btn-sm btn-light _hover shadow-sm"
                >
                  Try Again
                </a>
              )}
              {!passed && showAns === false && (
                <button
                  className="btn btn-sm bg-red _hover text-white ms-2 shadow-sm"
                  onClick={checkAnswers}
                  disabled={quiz.length !== Object.keys(answers).length}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
          <div style={{ height: 50 }}></div>
        </div>
      ) : (
        <div className="text-center mt-5">
          <p className="fw-bold mt-5 font-31">No data found</p>
        </div>
      )}
    </>
  );
};

export default React.memo(Quiz);
